import * as React from 'react';

const SoEmptyIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="240"
      height="140"
      viewBox="0 0 240 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="so-empty-illustration"
    >
      <ellipse
        cx="104.26"
        cy="131.18"
        rx="51.2598"
        ry="8.8189"
        fill="#E6E8E9"
      />
      <ellipse
        cx="135.677"
        cy="50.7087"
        rx="50.7087"
        ry="50.7087"
        fill="#E6E8E9"
      />
      <path
        d="M85.6874 55.1172C85.6874 55.1172 81.3199 66.3952 83.261 70.4019C85.2021 74.4085 88.2755 78.2668 88.2755 78.2668C88.2755 78.2668 87.1432 55.8592 85.6874 55.1172Z"
        fill="#F7F9FE"
      />
      <path
        opacity="0.590002"
        d="M85.6874 55.1172C85.6874 55.1172 81.3199 66.3952 83.261 70.4019C85.2021 74.4085 88.2755 78.2668 88.2755 78.2668C88.2755 78.2668 87.1432 55.8592 85.6874 55.1172Z"
        fill="#D3DFFB"
      />
      <path
        d="M88.0813 81.8677C88.0813 81.8677 87.7867 84.6559 87.6395 84.8026C87.4922 84.9494 87.7867 85.2429 87.6395 85.6831C87.4922 86.1234 87.3449 86.7103 87.6395 86.8571C87.934 87.0038 86.0194 99.9175 86.0194 99.9175C86.0194 99.9175 81.3067 106.081 83.2212 115.766L83.8103 125.598C83.8103 125.598 88.3758 125.892 88.3758 124.277C88.3758 124.277 88.0813 122.37 88.0813 121.489C88.0813 120.609 88.8176 120.609 88.3758 120.169C87.934 119.728 87.934 119.435 87.934 119.435C87.934 119.435 88.6704 118.848 88.5231 118.701C88.3758 118.554 89.8486 108.135 89.8486 108.135C89.8486 108.135 91.4686 106.521 91.4686 105.641V104.76C91.4686 104.76 92.2049 102.852 92.2049 102.706C92.2049 102.559 96.1813 93.6074 96.1813 93.6074L97.8014 100.064L99.5686 109.309C99.5686 109.309 100.452 117.674 102.22 120.902C102.22 120.902 105.312 131.468 105.312 131.175C105.312 130.881 110.467 130.147 110.32 128.827C110.172 127.506 107.227 109.016 107.227 109.016L107.963 81.5742L88.0813 81.8677Z"
        fill="#06103D"
      />
      <path
        d="M85.0836 125.019C85.0836 125.019 80.9593 131.881 83.7088 132.14C86.4583 132.399 87.5275 132.399 88.7495 131.363C89.4176 130.797 90.7705 130.037 91.8597 129.464C93.1767 128.784 93.9181 127.524 93.7682 126.223C93.6876 125.589 93.4084 125.067 92.721 125.019C90.888 124.889 88.7495 123.465 88.7495 123.465L85.0836 125.019Z"
        fill="#06103D"
      />
      <path
        d="M107.131 130.53C107.131 130.53 103.007 137.393 105.756 137.652C108.506 137.911 109.575 137.911 110.797 136.875C111.465 136.308 112.818 135.549 113.907 134.976C115.224 134.295 115.965 133.036 115.816 131.734C115.735 131.101 115.456 130.579 114.768 130.53C112.935 130.401 110.797 128.977 110.797 128.977L107.131 130.53Z"
        fill="#06103D"
      />
      <circle cx="102.606" cy="36.3778" r="6.61417" fill="#FCD3C9" />
      <path
        d="M98.7542 37.4805C98.7542 37.4805 94.1658 45.7934 93.7987 45.7934C93.4317 45.7934 102.058 48.5041 102.058 48.5041C102.058 48.5041 104.444 40.5526 104.811 39.8298L98.7542 37.4805Z"
        fill="#FCD3C9"
      />
      <path
        d="M105.428 47.6192C105.428 47.6192 96.3356 42.8509 95.4263 42.9954C94.5171 43.1399 84.8187 51.2315 84.9703 54.5548C85.1218 57.8781 86.3341 63.3688 86.3341 63.3688C86.3341 63.3688 86.7887 78.685 87.6979 78.8295C88.6072 78.974 87.5464 81.5749 87.8495 81.5749C88.1525 81.5749 109.065 81.5749 109.216 81.1414C109.368 80.7079 105.428 47.6192 105.428 47.6192Z"
        fill="#D3DFFB"
      />
      <path
        d="M108.912 81.5742C108.912 81.5742 111.761 90.6998 109.362 90.3852C106.963 90.0705 105.913 82.5182 105.913 82.5182L108.912 81.5742Z"
        fill="#FCD3C9"
      />
      <path
        d="M103.086 46.3139C103.086 46.3139 97.3718 47.4939 98.2984 54.869C99.225 62.244 100.924 69.6191 100.924 69.6191L106.638 81.5666L107.255 83.7791L111.425 82.7466L108.336 65.6365C108.336 65.6365 107.255 47.3464 105.866 46.7564C104.989 46.3995 104.036 46.2478 103.086 46.3139Z"
        fill="#D3DFFB"
      />
      <path
        opacity="0.1"
        d="M100.402 70.1237L105.913 82.6776L101.27 69.4492L100.402 70.1237Z"
        fill="black"
      />
      <path
        d="M108.76 34.7084L108.781 34.2006L109.734 34.452C109.714 34.1221 109.558 33.8184 109.307 33.621L110.323 33.5609C108.601 30.9682 105.953 29.2345 102.994 28.7622C100.797 28.4249 98.3516 28.913 96.8453 30.6403C96.1146 31.478 95.6556 32.5434 95.329 33.6304C94.7275 35.6322 94.605 38.0186 95.8591 39.6458C97.1338 41.2997 99.3603 41.6236 101.366 41.8283C102.072 41.9003 102.812 41.9673 103.466 41.6772C103.539 40.8823 103.443 40.0803 103.185 39.3298C103.077 39.0975 103.026 38.8407 103.035 38.5822C103.125 37.9499 103.921 37.7906 104.519 37.876C105.117 37.9615 105.836 38.0921 106.229 37.607C106.499 37.2728 106.483 36.7861 106.519 36.3474C106.617 35.153 108.75 34.9588 108.76 34.7084Z"
        fill="#06103D"
      />
      <ellipse
        cx="146.701"
        cy="124.566"
        rx="7.71654"
        ry="7.71654"
        fill="#2969F2"
      />
      <ellipse
        cx="61.8188"
        cy="122.363"
        rx="7.71654"
        ry="7.71654"
        fill="#2969F2"
      />
      <circle cx="61.8189" cy="112.441" r="5.51181" fill="#2969F2" />
      <ellipse
        cx="62.37"
        cy="105.276"
        rx="3.85827"
        ry="3.85827"
        fill="#2969F2"
      />
    </svg>
  );
});

SoEmptyIllustration.displayName = 'SoEmptyIllustration';

export { SoEmptyIllustration };
